module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_9.6462d8cda8c62c7cda5106519d88c9fd.png";